// in-animations.js — INSIDE scroll-entrance observer
// Watches [data-in-reveal] elements. Adds .in-pending when below fold,
// removes it (adding .in-revealed) when the element enters the viewport.
// CSS in in-motion.css handles the opacity/transform transition.
// Stagger: set style="--in-order: N" inline on each grouped element.
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function revealNow(el) {
    el.classList.remove('in-pending');
    el.classList.add('in-revealed');
  }

  function onEntry(entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        revealNow(entry.target);
        observer.unobserve(entry.target);
      } else {
        entry.target.classList.add('in-pending');
      }
    });
  }

  function init(root) {
    var els = (root || document).querySelectorAll('[data-in-reveal]:not(.in-revealed)');
    if (!els.length) return;
    var obs = new IntersectionObserver(onEntry, { rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify Customizer: reveal immediately in design mode (no animation).
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('[data-in-reveal]').forEach(revealNow);
    });
  }
})();
